import axiosClient from "./axiosClient";

export interface EnumPayload {
  page?: number;
  limit?: number;
  search?: string;
  sortName?: string;
  sortType?: string;
}

export interface EnumResponse {
  _id: string;
  name: string;
  keys: string[];
}

const enumApi = {
  getEnumList(data?: any): Promise<any> {
    const url = `/configurationEnum/getConfigurationEnums?page=${
      data?.page || ""
    }&limit=${data?.limit || ""}&search=${data?.search || ""}&sortField=${
      data?.sortName || ""
    }&sortType=${data?.sortType || ""}&enumType=${data?.enumType || ""}&type=${
      data?.type || ""
    }`;

    return axiosClient.get(url);
  },
  getEnumType(data?: any): Promise<any> {
    const url = `/configurationEnum/getEnumTypes?page=${
      data?.page || ""
    }&limit=${data?.limit || ""}&search=${data?.search || ""}&sortField=${
      data?.sortName || ""
    }&sortType=${data?.sortType || ""}`;

    return axiosClient.get(url);
  },
  addOrUpdateEnum(data: Record<string, any>): Promise<any> {
    const url = `/configurationEnum/addOrUpdateEnum`;
    return axiosClient.post(url, data);
  },
  deleteEnumKey(data: { enumType: string; keys: string[] }): Promise<any> {
    const url = `/configurationEnum/deleteEnum`;
    return axiosClient.delete(url, {
      headers: { "Content-Type": "application/json" },
      data,
    });
  },

  deleteEnumType(data: { enumType: string }): Promise<any> {
    const url = `/configurationEnum/deleteEnumType`;
    return axiosClient.delete(url, {
      headers: { "Content-Type": "application/json" },
      data,
    });
  },
};

export default enumApi;
